// extracted by mini-css-extract-plugin
export var svgPathFill = "cc_j0";
export var svgPathFillEvenOdd = "cc_j3";
export var svgPathFillNone = "cc_j4";
export var svgPathStroke = "cc_j1";
export var svgPathStrokeThree = "cc_j5";
export var svgPathStrokeWidthZero = "cc_j2";